import { Time } from "../custom-player.styled"

export const PlayerTime = (): JSX.Element => {
  return (
    <Time>
      <span id="custom-player-current-time">0:00</span> /{" "}
      <span id="custom-player-duration-time">0:00</span>
    </Time>
  )
}
